import styled from 'styled-components';

export const Paragraph = styled.p`
  font-weight: ${({ $bold, theme }) =>
    $bold ? theme.fontWeight.bold : 'inherit'};
  overflow-wrap: break-word;
`;
